import type { Insight as InsightProto } from '@taxfyle/api-internal/internal/insights_pb'
import type { InsightProps } from '@/features/jobs/details/insights/Insight'
import { Id } from '@/infra/id'
import { timestampToDate, safeTimestampToDate } from '@/utils/grpc-util'

export function mapInsightProtoToProps(
  jobId: Id,
  proto: InsightProto,
): InsightProps {
  return {
    jobId,
    prefixContent: proto.getPrefixContent(),
    generatedResponse: proto.getGeneratedResponse(),
    id: Id(proto.getInsightId()),
    dateGenerated: safeTimestampToDate(proto.getGeneratedTime()),
    isIrrelevant: proto.getIsIrrelevant(),
    dateMarkedIrrelevant:
      timestampToDate(proto.getDateMarkedIrrelevant()) ?? null,
  }
}
